<div class="min-h-screen flex flex-col bg-gray-50 pt-16">    <!-- Navbar -->
    <nav class="bg-indigo-600 shadow-lg fixed top-0 left-0 right-0 z-[9999]">
        <div class="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex justify-between h-16">
                <div class="flex"> <!-- Logo and hamburger menu -->
                    <div class="flex-shrink-0 flex items-center space-x-2">
                        <!-- Mobile menu button with animation -->
                        <button type="button"
                            class="md:hidden inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white hover:bg-indigo-700 focus:outline-none transition-all duration-300 ease-in-out"
                            (click)="toggleSidebar()" pRipple>
                            <span class="sr-only">{{sidebarVisible ? 'Close' : 'Open'}} sidebar</span>
                            <svg [class.rotate-90]="sidebarVisible"
                                class="h-6 w-6 transition-transform duration-300 ease-in-out"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>

                        <!-- Desktop toggle sidebar button - always visible and with higher z-index -->
                        <button type="button"
                            class="hidden md:inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white hover:bg-indigo-700 focus:outline-none transition-all duration-300 ease-in-out desktop-toggle-btn"
                            (click)="toggleSidebar()" pRipple>
                            <span class="sr-only">{{sidebarVisible ? 'Collapse' : 'Expand'}} sidebar</span>
                            <svg class="h-6 w-6 transition-transform duration-300 ease-in-out"
                                [ngClass]="{'transform rotate-180': !sidebarVisible}" xmlns="http://www.w3.org/2000/svg"
                                fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
                            </svg>
                        </button>

                        <!-- Logo -->
                        <span class="text-white text-xl font-semibold navbar-title">Aeroserv FBO</span>
                    </div>
                </div> <!-- Right side nav items -->
                <div class="flex items-center">
                    <span *ngIf="userName$ | async as userName"
                        class="navbar-user-name hidden sm:block text-white text-sm font-medium truncate max-w-[16rem]"
                        [title]="userName">
                        {{ userName }}
                    </span>

                    <!-- Profile dropdown -->
                    <div class="ml-3 relative user-menu-container">
                        <div>
                            <button type="button"
                                class="w-10 h-10 flex items-center justify-center rounded-full bg-indigo-700 hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-700 focus:ring-white transition"
                                pRipple (click)="toggleUserMenu($event)">
                                <i class="pi pi-user text-white text-xl"></i>
                            </button>
                        </div>

                        <!-- User dropdown menu -->
                        <div *ngIf="isUserMenuOpen"
                            class="user-menu origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                            role="menu" [ngClass]="{'animate-dropdown': isUserMenuOpen}">
                            <button (click)="openChangePassword()"
                                class="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                role="menuitem">
                                <svg class="mr-3 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                                </svg>
                                Cambiar contraseña
                            </button>
                            <button (click)="logout()"
                                class="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                role="menuitem">
                                <svg class="mr-3 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                </svg>
                                Cerrar Sesión
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>    </nav>    <div class="flex flex-1 overflow-hidden relative w-full">        
        <!-- Mobile overlay - full screen (only shown on mobile) -->
        <div *ngIf="sidebarVisible && isMobile" (click)="toggleSidebar()"
            class="md:hidden fixed inset-0 bg-gray-900 bg-opacity-75 z-50 transition-all duration-300 ease-in-out animate-fade-in">
        </div>
        
        <!-- Sidebar with enhanced transitions -->
        <aside [ngClass]="{
        'sidebar': true,
        'sidebar-visible': sidebarVisible,
        'sidebar-hidden': !sidebarVisible,
        'sidebar-transition': true,
        'mobile-sidebar': isMobile
      }" [ngStyle]="{'top': '4rem'}" class="fixed left-0 transform z-[9999] h-[calc(100vh-4rem)] overflow-hidden">
            <div class="flex flex-col w-64 bg-white shadow-lg h-full overflow-hidden" [ngClass]="{'animate-slide-in': sidebarVisible}">
                <!-- Close button for mobile -->
                <button (click)="toggleSidebar()"
                    class="md:hidden sidebar-close-btn p-2 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 hover:text-gray-700 transition-colors duration-200 absolute top-2 right-2"
                    pRipple>
                    <span class="sr-only">Close sidebar</span>
                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto h-full">
                    <div class="flex items-center flex-shrink-0 px-4">
                        <h2 class="text-lg font-medium text-gray-900">Navegación</h2>
                    </div>                    
                    <nav class="mt-5 flex-1 px-2 space-y-1">
                        <!-- Navigation Links -->
                          <a routerLink="/home/dashboard" routerLinkActive="bg-indigo-100 text-indigo-900"
                            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-indigo-50 hover:text-indigo-900"
                            pRipple>
                            <svg class="text-gray-400 group-hover:text-indigo-500 mr-3 flex-shrink-0 h-6 w-6"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 19v-6a2 2 0 012-2h2a2 2 0 012 2v6m-9 0h10a2 2 0 002-2V9.5a1 1 0 00-.4-.8l-5-3.75a1 1 0 00-1.2 0l-5 3.75a1 1 0 00-.4.8V17a2 2 0 002 2z" />
                            </svg>
                            Dashboard
                        </a>
                        <a routerLink="/home/message-center" routerLinkActive="bg-indigo-100 text-indigo-900"
                            [routerLinkActiveOptions]="{exact: true}"
                            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-indigo-50 hover:text-indigo-900"
                            pRipple>
                            <svg class="text-gray-400 group-hover:text-indigo-500 mr-3 flex-shrink-0 h-6 w-6"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                            </svg>
                            Centro de mensajes
                        </a>

                        <a routerLink="/home/surveys" routerLinkActive="bg-indigo-100 text-indigo-900"
                            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-indigo-50 hover:text-indigo-900"
                            pRipple>
                            <svg class="text-gray-400 group-hover:text-indigo-500 mr-3 flex-shrink-0 h-6 w-6"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.519 4.674c.3.921-.755 1.688-1.539 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.784.57-1.838-.197-1.539-1.118l1.519-4.674a1 1 0 00-.363-1.118L3.077 10.1c-.783-.57-.38-1.81.588-1.81H8.58a1 1 0 00.95-.69l1.519-4.674z" />
                            </svg>
                            Encuestas
                        </a>

                        <a routerLink="/home/services-builder" routerLinkActive="bg-indigo-100 text-indigo-900"
                            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-indigo-50 hover:text-indigo-900"
                            pRipple>
                            <svg class="text-gray-400 group-hover:text-indigo-500 mr-3 flex-shrink-0 h-6 w-6"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a3 3 0 006 0M9 5a3 3 0 016 0m-6 8l2 2 4-4" />
                            </svg>
                            Catálogo de servicios
                        </a>

                        <a routerLink="/home/custom-responses" routerLinkActive="bg-indigo-100 text-indigo-900"
                            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-indigo-50 hover:text-indigo-900"
                            pRipple>
                            <svg class="text-gray-400 group-hover:text-indigo-500 mr-3 flex-shrink-0 h-6 w-6"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                            </svg>
                            Respuestas personalizadas
                        </a>

                        <a routerLink="/home/users" routerLinkActive="bg-indigo-100 text-indigo-900"
                            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-indigo-50 hover:text-indigo-900"
                            pRipple>
                            <svg class="text-gray-400 group-hover:text-indigo-500 mr-3 flex-shrink-0 h-6 w-6"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                            Usuarios
                        </a>
                    </nav>
                </div>
            </div>
        </aside>

        <!-- Main content - Will be pushed by sidebar when it's open -->
        <div class="flex-1 overflow-auto focus:outline-none main-content w-full md:relative"
            [ngClass]="{'expanded-content': !sidebarVisible, 'sidebar-open': sidebarVisible}" tabindex="0">
            <main class="flex-1 relative z-0 overflow-y-auto w-full">
                <div class="w-full">
                    <!-- Router outlet for content - Sin padding para permitir que los componentes controlen su espacio -->
                    <router-outlet></router-outlet>
                </div>
            </main>
        </div>
    </div>
</div>

<app-change-password-dialog *ngIf="showChangePasswordDialog" (closed)="showChangePasswordDialog = false"></app-change-password-dialog>
